export default "__VITE_ASSET__6f7d1994__"